import React from 'react';
import {
  FaTools,
  FaDraftingCompass,
  FaWarehouse,
  FaProjectDiagram,
  FaHardHat,
  FaCheckCircle,
  FaFlagCheckered,
  FaFileSignature,
} from 'react-icons/fa';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import './Rotate.css';
import img1 from '../../assets/images/2.jpg';

const expertise = [
  { icon: <FaTools />, label: 'Project Initiation' },
  { icon: <FaDraftingCompass />, label: 'Detailed Engineering Design' },
  { icon: <FaWarehouse />, label: 'Procurement' },
  { icon: <FaProjectDiagram />, label: 'Construction Planning' },
  { icon: <FaHardHat />, label: 'Construction Execution' },
  { icon: <FaCheckCircle />, label: 'Commissioning and Testing' },
  { icon: <FaFlagCheckered />, label: 'Handover and Delivery' },
  { icon: <FaFileSignature />, label: 'Project Closeout' },
];

const Rotate = () => {
  const navigate = useNavigate();

  return (
    <div className="w-full min-h-screen bg-gradient-to-br from-gray-100 to-white flex flex-col md:flex-row items-center justify-center px-4 md:px-20 gap-10 md:gap-20 overflow-hidden py-10">
      
      {/* Rotating Expertise Circle */}
      <div className="relative circle-wrapper">
        {/* Center element */}
        <div className="absolute top-1/2 left-1/2 center-circle">
          Our<br />Process
        </div>

        {/* Rotating icons */}
        <div className="absolute inset-0 origin-center animate-rotate-circle">
          {expertise.map((item, index) => {
            const total = expertise.length;
            const angle = (360 / total) * index;
            const radius = window.innerWidth < 768 ? 120 : 270; // responsive radius
            const rad = (angle * Math.PI) / 180;
            const x = radius * Math.cos(rad);
            const y = radius * Math.sin(rad);

            return (
              <div
                key={index}
                className="absolute flex flex-col items-center justify-center icon-wrapper"
                style={{
                  top: `calc(50% + ${y}px)`,
                  left: `calc(50% + ${x}px)`,
                  transform: 'translate(-50%, -50%)',
                }}
              >
                <div className="expertise-icon rotate-unwind text-[#e6b127] cursor-pointer">
                  <div className="icon">{React.cloneElement(item.icon, { size: window.innerWidth < 768 ? 24 : 40 })}</div>
                  <p className="label">{item.label}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {/* Animated Slogan Card */}
      <motion.div
        initial={{ opacity: 0, x: 100 }}
        whileInView={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.8, ease: 'easeOut' }}
        viewport={{ once: true }}
        className="max-w-md w-full bg-white/60 backdrop-blur-lg border border-gray-200 rounded-2xl shadow-2xl p-4 md:p-6 flex flex-col items-center text-center"
      >
        <img
          src={img1}
          alt="Industrial"
          className="w-full h-48 md:h-64 object-cover rounded-xl mb-4"
          loading='lazy'
        />
        <h2 className="text-xl md:text-2xl font-bold text-gray-800 mb-2 tracking-wide">Design To Deliver</h2>
        <p className="text-gray-600 text-sm md:text-base mb-4 leading-relaxed">
          Labh Industries transforms innovative designs into reliable EPC solutions, ensuring seamless execution from concept to completion.
        </p>
        <button
          onClick={() => navigate('/service')}
          className="mt-2 bg-[#5bc0fe] hover:bg-yellow-600 text-white font-semibold py-2 px-6 rounded-full transition-all duration-300 ease-in-out shadow-md hover:shadow-lg"
        >
          Explore Services
        </button>
      </motion.div>
    </div>
  );
};

export default Rotate;
